import { useEffect } from 'react';
import ToastContainer from 'components/_UI/ToastsContainer';
import useToast from 'hooks/useToast';
import { PANEL_PERMISSION_DENIED_EVENT } from 'helpers/actingProducer';

/**
 * Rede de segurança do painel de equipe: quando a API recusa uma ação por
 * falta de permissão (a tela ainda oferecia o botão), a pessoa vê o motivo em
 * vez de um clique que não faz nada.
 */
export default function PanelPermissionToast() {
    const { toast, toasts } = useToast();

    useEffect(() => {
        function onDenied(event) {
            toast.error(event.detail?.message || 'Sua equipe não tem permissão para esta ação.', { position: 'top-center' });
        }

        window.addEventListener(PANEL_PERMISSION_DENIED_EVENT, onDenied);

        return () => window.removeEventListener(PANEL_PERMISSION_DENIED_EVENT, onDenied);
    }, []);

    return <ToastContainer toasts={toasts} />;
}
